import { IMenuItemService } from "../../service/menu/MenuItemService";

export default class GetAllRootMenuItemsInteractor {
  private menuItemService: IMenuItemService;

  constructor(menuItemService) {
    this.menuItemService = menuItemService;
  }

  async execute() {
    return this.menuItemService.getAllRootMenuItems();
  }
}
